export const StateName = 'EntityInfoPageState';
export const EntityInfoPageStateName = StateName;

export interface EntityInfoPageData {
  filterText: string;
}

export interface EntityInfoPageState {
  /** Key is `entityId_{entityId}:campaignId_{campaignId} */
  keyed_entity_info_pages: {
    [key: string]: EntityInfoPageData;
  };
}

export const initialState: EntityInfoPageState = {
  keyed_entity_info_pages: {}
};
